module.exports = __webpack_public_path__ + "static/img/wglogin.fe3db4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/wglogin.png
// module id = Auj7
// module chunks = 66